import React from 'react'
import { Container, createStyles, withStyles } from '@material-ui/core'

import Levels from './Levels'
import Logo from './Logo'
import Company from './Company'
import { expandFooterLinks } from './styles'

const styles = (theme) => {
  const expandBreakpointUp = theme.breakpoints.up('md')
  return createStyles({
    footer: {
      padding: '3.3125rem 0',
      backgroundColor: 'white',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [expandBreakpointUp]: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      },
    },
    links: {
      marginTop: '3rem',
      width: '100%',
      [theme.breakpoints.up(expandFooterLinks)]: {
        display: 'flex',
        marginLeft: '3rem',
      },
      [expandBreakpointUp]: {
        width: 'auto',
      },
    },
  })
}

const Footer = ({ classes }) => {
  return (
    <footer className={classes.footer}>
      <Container maxWidth="xl">
        <div className={classes.content}>
          <Logo />
          <div className={classes.links}>
            <Levels />
            <Company />
          </div>
        </div>
      </Container>
    </footer>
  )
}

export default withStyles(styles)(Footer)
